module.exports = __webpack_public_path__ + "static/analysisIcon-3eb68e67491ba5e520f2633048b1c61e.png";